// =============================================================
// 航富通 Nova（旗舰版）核心差异
// 定位：客户群体、核心功能与标准版一致；
//       Nova 旗舰差异 = 性能、操作便捷性、更快迭代、更多新功能、专属服务。
// 来源：用户明确口径
// =============================================================

export const novaCapabilities = [
  {
    title: '更快性能',
    desc: '引擎级性能优化，开单、查询、报表更流畅响应更快',
    icon: 'rocket',
    isPending: false,
  },
  {
    title: '更便捷操作',
    desc: '智能化操作流程，减少点击与等待，开单收银更省心',
    icon: 'check',
    isPending: false,
  },
  {
    title: '更快迭代',
    desc: '新品功能优先上线，让门店始终用上更先进的工具',
    icon: 'sync',
    isPending: false,
  },
  {
    title: '更多新功能',
    desc: '优先体验持续新增的能力，满足不断成长的经营需求',
    icon: 'star',
    isPending: false,
  },
  {
    title: '专属服务支援',
    desc: '优先客服、一对一实施、专属售后响应更及时',
    icon: 'service',
    isPending: true,
  },
  {
    title: '开放与集成',
    desc: '对接集团 ERP、财务系统、外部平台（建议补充）',
    icon: 'link',
    isPending: true,
  },
]

// Nova 功能全景（以旗舰体验为核心）
export const novaModules = [
  { title: '更快的响应', desc: '开单查询快到飞起' },
  { title: '更省心的流程', desc: '智能化操作更便捷' },
  { title: '持续的新功能', desc: '更快迭代、先人一步' },
  { title: '专业的支援', desc: '专属服务、快速响应' },
]

// Nova 套餐数据
// 来源：用户提供口径
export const novaPackages = [
  { hardware: '手机套餐', standardPrice: '1288元' },
  { hardware: '通用套餐', standardPrice: '2088元' },
  { hardware: '平板套餐', standardPrice: '3388元' },
  { hardware: '一体机套餐', standardPrice: '3888元' },
]



// WEBPACK FOOTER //
// ./src/site/data/nova.js